// store/modules/config.js
// import axiosInstance from "@/services/axios";
import {remoteConfig} from "@/firebase";
const state = {
  userName: "",
  theme: "#ffffff",
  expiry_date: "",
  app_name: "",
  category: [],
};

const mutations = {
  SET_CONFIG(state, payload) {
    Object.assign(state, payload);
  },
};

const actions = {
  async fetchConfig({ commit }) {
    try {
      // const res = await axiosInstance.get('/api/config');
      // const data = res?res.data.info:"";
      remoteConfig.fetchAndActivate().then(() => {
          let appName = remoteConfig.getString("app_name");
          let appAddress = remoteConfig.getString("app_address");
          let appTheme = remoteConfig.getString("app_theme");
          let expiryDate = remoteConfig.getString("expiry_date");
          let category = JSON.parse(remoteConfig.getString("category"));
          let ownerName =  remoteConfig.getString("owner_name");
          let branchName = remoteConfig.getString("branch_name");

          let config = {
            theme: appTheme,
            expiry_date: expiryDate,
            app_name: appName,
            app_address: appAddress,
            category: category,
            ownerName: ownerName,
            branchName: branchName
          };

      commit("SET_CONFIG", config);
      console.log("SET_CONFIG", config);

          console.log("Remote Config fetched:", config);
        })
        .catch((err) => {
          console.error("Remote Config error:", err);
        });


    } catch (err) {
      console.error("Failed to fetch config:", err);
    }
  },
};

const getters = {
  config: (state) => state,
  isSubscriptionExpired: (state) => {
    console.log("config: "+ state.expiry_date)
    if (!state.expiry_date) return false;
    const now = new Date();
    console.log("Now: " + now);
    const [day, month, year] = state.expiry_date.split("-");
    const expiry = new Date(`${year}-${month}-${day}`);
    console.log("Expiry: " + expiry);
    return now > expiry;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
